import moment from "moment";

export const getRemainingDays = (enddate) => {
    let current = moment(new Date());
    enddate = new Date(enddate);
    enddate.setHours(0, 0, 0);
    enddate = moment(enddate);

    let diff = enddate.diff(current, 'days');

    return diff >= 0 ? diff : 0;
};

export const getDaysBeforeStart = (startdate) => {
    let current = moment(new Date());
    startdate = new Date(startdate);
    startdate.setHours(0, 0, 0);
    startdate = moment(startdate);

    let diff = startdate.diff(current, 'days');

    return diff >= 0 ? diff : 0;
};

export const getAge = (birthday) => {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const getNumberOfWeeksInAYear = (year) => {
    let d = moment(new Date(year, 11, 31));
    let week = d.week();
    return week == 1 ? 52 : week;
}

export const getWeeksBetweenDates = (firstWorkoutDate, endDate = new Date()) => {
    let start = moment(new Date(firstWorkoutDate));
    let end = moment(new Date(endDate));

    let sY = start.year();
    let eY = end.year();

    let sW = start.week();
    let eW = end.week();

    let min = 0, max = 0;
    let weeks = [];

    for (let x = sY; x <= eY; x++) {
        max = x < eY ? getNumberOfWeeksInAYear(x) : eW;
        min = x == sY ? sW : 1;
        for (let y = min; y <= max; y++) {
            weeks.push(`${x}-${(y + "").padStart(2, "0")}`);
        }

    }

    // sort the weeks
    weeks = weeks.sort((b, a) => {
        let aYear = a.split("-")[0];
        let aWeek = a.split("-")[1];

        let bYear = b.split("-")[0];
        let bWeek = b.split("-")[1];

        if (aYear == bYear) {
            return aWeek - bWeek;
        } else {
            return aYear - bYear;
        }
    });

    return weeks;
}